import React, { useState, useEffect, startTransition } from 'react';
import {
  HashRouter as Router,
  Routes,
  Route,
  NavLink,
  Navigate,
  useLocation,
} from 'react-router-dom';

import AtoZView from 'views/AtoZView';
import SearchView from 'views/SearchView';
import AcronymView from 'views/AcronymView';
import GlossaryView from 'views/GlossaryView';

function AppRoutes() {
  const location = useLocation();

  const hasHashRoute = window.location.hash.startsWith('#/');
  const isReferenceDataRoute = location.pathname === '/reference-data';

  const [longid, setLongid] = useState('');

    useEffect(() => {
      const observer = new MutationObserver(() => {
        const el =
          document.querySelector('[data-longid]') ||
          document.getElementById('app');

        const foundLongId = el?.dataset?.longid;

        if (foundLongId) {
          console.log('foundlongid: ', foundLongId)
          setLongid(foundLongId);
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return () => observer.disconnect();
    }, []);

  if (isReferenceDataRoute) {
    return (
      <Routes>
        <Route path="/reference-data" element={<GlossaryView  />} />
      </Routes>
    );
  }



  return (
    <>
      <header className="">
        <nav className="pt-4">
          <div className="flex">
            <NavLink
              to="/search"
              className={({ isActive }) =>
                `rounded-tl-lg inline-block p-4 no-underline ${
                  isActive
                    ? 'text-white bg-ubc-blue hover--text-white'
                    : 'bg-ubc-blue/30 text-ubc-blue hover--bg-ubc-blue/20'
                }`
              }
            >
              Search All
            </NavLink>

            <NavLink
              to="/a-z"
              className={({ isActive }) =>
                `inline-block p-4 no-underline ${
                  isActive
                    ? 'text-white bg-ubc-blue hover--text-white'
                    : 'bg-ubc-blue/30 text-ubc-blue hover--bg-ubc-blue/20'
                }`
              }
            >
              A-Z Listing
            </NavLink>

            <NavLink
              to="/acronyms"
              className={({ isActive }) =>
                `rounded-tr-lg inline-block p-4 no-underline ${
                  isActive
                    ? 'text-white bg-ubc-blue hover--text-white'
                    : 'bg-ubc-blue/30 text-ubc-blue hover--bg-ubc-blue/20'
                }`
              }
            >
              Acronyms
            </NavLink>
          </div>
        </nav>
      </header>

      <main className="">
        <Routes>
          <Route path="/" element={<Navigate to="/search" />} />
          <Route path="/search" element={<SearchView longid={longid} />} />
          <Route path="/a-z" element={<AtoZView longid={longid} />} />
          <Route path="/acronyms" element={<AcronymView longid={longid} />} />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
